import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { GetAppRounded } from "@mui/icons-material";

export function DownloadSingleReportButton({ onClick }) {
    return (
        <ButtonContainer onClick={onClick}>
            <GetAppRounded color="primary" aria-hidden="true" />
            <span>Download report</span>
        </ButtonContainer>
    );
}

const ButtonContainer = styled.button`
    display: flex;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    outline-color: ${({ theme }) => theme.primary};
    outline-width: thin;

    span {
        margin-top: -2px;
        margin-left: 3px;
    }
`;

DownloadSingleReportButton.propTypes = {
    onClick: PropTypes.func
};
